var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNormanRecords(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 20C20.4183 20 24 16.4183 24 12C24 7.58172 20.4183 4 16 4C11.5817 4 8 7.58172 8 12C8 16.4183 11.5817 20 16 20Z",
    fill: "#101010"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9998 13.6004C16.8837 13.6004 17.6002 12.8839 17.6002 12C17.6002 11.1162 16.8837 10.3997 15.9998 10.3997C15.1159 10.3997 14.3994 11.1162 14.3994 12C14.3994 12.8839 15.1159 13.6004 15.9998 13.6004Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9994 12.3198C16.1759 12.3198 16.3191 12.1767 16.3191 12.0001C16.3191 11.8236 16.1759 11.6804 15.9994 11.6804C15.8228 11.6804 15.6797 11.8236 15.6797 12.0001C15.6797 12.1767 15.8228 12.3198 15.9994 12.3198Z",
    fill: "#101010"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 4H16V20H0V4Z",
    fill: "#4876C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNormanRecords);
export default __webpack_public_path__ + "static/media/norman-records.1669038c.svg";
export { ForwardRef as ReactComponent };